import { useLocation } from "react-router-dom";
import {
  shape1BL,
  shape1BR,
  shape2BR,
  shape2TL,
  spikeBL,
  spikeBR,
  spikeTL,
  spikeTR,
} from "../../../../Assets";
import routes from "../../../../Utils/routes";

const LayoutElements = () => {
  const location = useLocation();
  const pathName = location.pathname;
  return (
    <>
      {pathName === routes.iconPlayers || pathName === routes.teamDetails ? (
        <>
          <img
            src={shape1BL}
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
          <img
            src={shape1BR}
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
        </>
      ) : pathName === routes.squadList ? (
        <>
          {" "}
          <img
            src={shape2BR}
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
          <img
            src={shape2TL}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
        </>
      ) : (
        <>
          <img
            src={spikeBL}
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
          <img
            src={spikeBR}
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
          <img
            src={spikeTR}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
          <img
            src={spikeTL}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: "1",
              width: "10vw",
              height: "auto",
            }}
            alt="element"
          />
        </>
      )}
    </>
  );
};

export default LayoutElements;
